export default __webpack_public_path__ + "static/media/first-screen-image.ed7c1210.svg";